import React, { Component } from 'react'
import Table from './Table'
import Store from './store'
import { Provider, inject } from 'mobx-react'

@inject('pageStore')
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store(props.pageStore)
  }

  render() {
    return (
      <Provider store={this.store}>
        <Table />
      </Provider>
    )
  }
}
